import React from "react";
import "../../App.css";
import CardAbout from "../CardAbout";
import Footer from "../Footer";
import AboutSection from "../AboutSection";
import Banner from "../Banner";
import HeaderInvert from "../HeaderInvert";
import ValuesSection from "../Values";
import Cta from "../Cta";

export default function About() {
  return (
    <>
      <AboutSection />
      <HeaderInvert text="TWO CREATIVES, ONE MISSION: TURNING SPACES INTO UNFORGETTABLE STORIES." />
      <ValuesSection />
      <Cta
        headline="Ready to bring your ideas to life?"
        subtext="Contact us today and let’s make it happen."
        buttonLink="./portfolio"
        buttonText="Get in Touch"
      />
      <Footer />
    </>
  );
}
